module.exports = "https://static.moomoo.com/components/top-trading-signals/images/ai_analyst_bg.d8f0d72965.png";